<div mat-dialog-content>
  <h2>Slett nåværende og start nytt salg?</h2>
  <p>Hele bestillingen vil bli slettet og du vil gå tilbake til start.</p>
</div>

<div mat-dialog-actions>
  <div class="buttons">
    <app-ice-button
      color="secondary"
      id="reset-sale"
      testId="reset-sale-button"
      (click)="confirmReset()"
    >
      Start nytt salg
    </app-ice-button>
    <app-ice-button color="outlined" matDialogClose testId="stay-in-sale-button" (click)="abort()">
      Bli på værende
    </app-ice-button>
  </div>
</div>
